export default __webpack_public_path__ + "static/media/step3.d1448d19.webp";